import { Incident } from "one-state-incidents/src/Incidents";

/**
 * This Function transforms the backend response
 * in the Data Model that supports the
 * Pending Referal component
 * @param response is the raw json data returned from API.
 * @param context has settings etc..
 */

export const TransformResponse = (response: any, context: any) => {
    /**
     * @param result contains the transformed response
     */
     let result: any[] = [];

     let incidentresult: any = {
         callerincidentdata: result,
         error: undefined
 
     }
     let responseinfo = [];
    if (response && (response.status >= 400 || response.type == "error")) {
        incidentresult.error = response;
    }
    else if (response && response.length > 0) {
      
        if(response && response.length> 0) {
            response.map ((incidentinfo: any)=> {
                let data: Incident = {
                    sys_id: "",
                    number: "",
                    priority: "",
                    short_description:"",
                    state:"",
                    sys_created_on:""
                }
            if(incidentinfo?.result && incidentinfo.result.length > 0) {
                incidentinfo.result.map((incidentdata: any)=>{
                    data.sys_id = incidentdata.sys_id ? incidentdata.sys_id : "";
                    data.number = incidentdata.number ? incidentdata.number : "";
                    data.priority = incidentdata.priority ? incidentdata.priority : "";
                    data.short_description = incidentdata.short_description ? incidentdata.short_description : "";
                    data.state =incidentdata.state ? incidentdata.state : "";
                    data.sys_created_on = incidentdata.sys_created_on ? incidentdata.sys_created_on : "";
                    result.push(incidentdata)
                })
            }
            })
        }
    }
    incidentresult.callerincidentdata = result;
    return incidentresult;
}